import { render, staticRenderFns } from "./sidebar-scalapay.vue?vue&type=template&id=70a85d21&"
import script from "./sidebar-scalapay.vue?vue&type=script&lang=js&"
export * from "./sidebar-scalapay.vue?vue&type=script&lang=js&"
import style0 from "./sidebar-scalapay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports